/**
 * APICore: WEHAGO API 기본 유틸리티
 * 원본: wehago-conference/src/utils/apiV2/apiCore.js
 *
 * - 인증 토큰/회사번호 쿠키/스토리지 조회
 * - 비인증 서명 생성
 * - 요청 헤더 생성
 */
import axios from 'axios';
import CryptoJS from 'crypto-js';
import { getRequestHeadersChange } from './signHeader';
import apiConfig from './config';
import { getCookie } from '@/utils/cookie';

class APICore {
  readonly serviceCode = 'communication';

  getStorageKeyData(key: string): string | null {
    if (getCookie(key)) return getCookie(key);
    if (localStorage.getItem(key)) return localStorage.getItem(key);
    if (sessionStorage.getItem(key)) return sessionStorage.getItem(key);
    return null;
  }

  get authAToken(): string | null {
    return this.getStorageKeyData('AUTH_A_TOKEN');
  }

  get hSelectedCno(): string | null {
    return this.getStorageKeyData('h_selected_company_no');
  }

  get hSelectedCCode(): string | null {
    return this.getStorageKeyData('h_selected_company_code');
  }

  /** 비인증 API 용 토큰 획득 (서명은 일회성 — 캐시 금지) */
  getToken = async (url: string, tokenBaseUrl?: string): Promise<string> => {
    const base = tokenBaseUrl ?? apiConfig.baseGuestUrl;
    const apiUrl = `${base}/get_token?url=${url}`;
    const { data } = await axios.get<{ cur_date: string; token: string }>(apiUrl);
    return `${data.cur_date}${data.token}`;
  };

  /** Base64(SHA256) 서명 */
  createSignature = (url: string): string =>
    CryptoJS.enc.Base64.stringify(CryptoJS.SHA256(url));

  /** 비인증 서명 생성 */
  getUnAuthSignature = async (url: string, tokenBaseUrl?: string): Promise<string> => {
    const token = await this.getToken(url, tokenBaseUrl);
    return this.createSignature(`${url}${token}`);
  };

  /** 인증 요청 헤더 반환 */
  getRequestHeaders = (url: string): Record<string, string | number | boolean> =>
    getRequestHeadersChange(url);
}

export default APICore;

/** 싱글턴 인스턴스 — 여러 모듈에서 `new APICore()` 대신 사용 */
export const apiCore = new APICore();
